export default "__VITE_ASSET__Biw_$OFe__"